import { IButtonLayout } from '../../types/layout/button';

function Button({
    className, disabled, title, href, hrefTarget,
}: IButtonLayout) {
    if (typeof href === 'string') {
        return (
            <a aria-disabled={disabled} className={className || 'btn btn-link'} href={href} target={hrefTarget}>
                <div dangerouslySetInnerHTML={{ __html: title }} />
            </a>
        );
    }
    return (
        <button className={className || 'btn btn-primary'} type="button">
            <div dangerouslySetInnerHTML={{ __html: title }} />
        </button>
    );
}

export default Button;
